// Native Audio Bridge helpers for Capacitor Android
// Uses window.NativeAlarm injected by NativeAlarmBridge.java
// Web fallback: these functions are only called when isNativeAudioAvailable() returns true

const getBridge = (): any => (window as any).NativeAlarm;

/** Check if running in Capacitor with native audio bridge */
export const isNativeAudioAvailable = (): boolean => {
  return typeof getBridge()?.playAudio === 'function';
};

/** Start native audio playback */
export const nativePlayAudio = (url: string, title: string, artist: string): boolean => {
  try {
    console.log('[NativeAudio] playAudio:', title, url);
    const result = getBridge()?.playAudio(JSON.stringify({ url, title, artist }));
    console.log('[NativeAudio] playAudio result:', result);
    return result ? JSON.parse(result).success : false;
  } catch (e) { console.error('[NativeAudio] playAudio error:', e); return false; }
};

export const nativePauseAudio = (): void => {
  try { getBridge()?.pauseAudio(); } catch (e) { /* ignore */ }
};

export const nativeResumeAudio = (): void => {
  try { getBridge()?.resumeAudio(); } catch (e) { /* ignore */ }
};

export const nativeStopAudio = (): void => {
  try { getBridge()?.stopAudio(); } catch (e) { /* ignore */ }
};

export const nativeSeekAudio = (positionMs: number): void => {
  try { getBridge()?.seekAudio(String(Math.round(positionMs))); } catch (e) { /* ignore */ }
};

export const nativeSetLooping = (loop: boolean): void => {
  try { getBridge()?.setAudioLooping(String(loop)); } catch (e) { /* ignore */ }
};

export interface NativeAudioState {
  playing: boolean;
  position: number; // milliseconds
  duration: number; // milliseconds
  completed: boolean;
}

/** Get current native audio state (position/duration in ms) */
export const nativeGetAudioState = (): NativeAudioState | null => {
  try {
    const result = getBridge()?.getAudioState();
    return result ? JSON.parse(result) : null;
  } catch (e) { return null; }
};
